import { CreditFactorTradeline } from '@generated-gql/generated-types';
import classes from '@nerdwallet/base-styles/classes';

import styles from './tradeline-list.module.scss';

export interface TradelineListProps {
  maxTradelinesToShow?: number; // zero denotes no limit
  tradelines: CreditFactorTradeline[];
  TradelineListItem: React.FC<{ tradeline: CreditFactorTradeline }>;
}

const TradelineList: React.FC<TradelineListProps> = ({
  maxTradelinesToShow = 0,
  tradelines = [],
  TradelineListItem,
}) => (
  <ul className={classes('width-100')}>
    {(maxTradelinesToShow
      ? tradelines.slice(0, maxTradelinesToShow)
      : tradelines
    ).map((tradeline, index) => (
      <li key={index} className={styles.listItem}>
        <TradelineListItem tradeline={tradeline} />
      </li>
    ))}
  </ul>
);

export default TradelineList;
